import React from 'react'

export const BookingsDashboardSkeleton = () => {
    return (
        <div className="animate-pulse">
            {/* Stats Cards Skeleton */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
                {[...Array(5)].map((_, i) => (
                    <div
                        key={i}
                        className="bgwhite p-4 rounded-lg shadow-lg border border-gray-100 flex items-center justify-between"
                    >
                        <div className="w-full">
                            <div className="h-4 bg-gray-200 rounded w-2/3 mb-2"></div>
                            <div className="h-5 bg-gray-200 rounded w-1/3"></div>
                        </div>
                        <div className="w-10 h-10 bg-gray-200 rounded-xl ml-4"></div>
                    </div>
                ))}
            </div>

            {/* Charts Row */}
            <div className="flex flex-col lg:flex-row gap-4">
                {/* VIP vs Standard Chart Skeleton */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-full lg:w-[35%]">
                    <div className="h-6 bg-gray-200 rounded w-1/4 mb-4"></div>
                    <div className="h-[150px] bg-gray-200 rounded mb-4"></div>
                    <div className="space-y-4 px-4">
                        {[...Array(2)].map((_, i) => (
                            <div key={i} className="flex justify-between items-center">
                                <div className="flex items-center gap-2">
                                    <div className="w-8 h-8 bg-gray-200 rounded-lg"></div>
                                    <div className="h-4 bg-gray-200 rounded w-16"></div>
                                </div>
                                <div className="h-4 bg-gray-200 rounded w-12"></div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Boat Availability Skeleton */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-full lg:w-[30%]">
                    <div className="h-6 bg-gray-200 rounded w-1/2 mb-6"></div>
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className="mb-4">
                            <div className="flex justify-between mb-2">
                                <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                                <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                            </div>
                            <div className="h-2 bg-gray-200 rounded w-full"></div>
                        </div>
                    ))}
                    <div className="h-5 bg-gray-200 rounded w-2/3 mt-8"></div>
                </div>

                {/* Demographics Skeleton */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-full lg:w-[35%]">
                    <div className="h-6 bg-gray-200 rounded w-1/2 mb-6"></div>
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className="flex items-center gap-4 mb-4">
                            <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
                            <div className="flex-1">
                                <div className="flex justify-between mb-2">
                                    <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                    <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                </div>
                                <div className="h-3 bg-gray-200 rounded w-full"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Hourly Performance Chart Skeleton */}
            <div className="bgwhite p-4 mt-6 rounded-xl shadow-lg border border-gray-100 w-full mb-6">
                <div className="h-6 bg-gray-200 rounded w-1/4 mb-4"></div>
                <div className="h-[300px] bg-gray-200 rounded"></div>
            </div>

            {/* Bottom Row */}
            <div className="flex gap-x-4 mt-6">
                {/* Routes Skeleton */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-[45%]">
                    <div className="h-6 bg-gray-200 rounded w-1/2 mb-6"></div>
                    {[...Array(4)].map((_, i) => (
                        <div key={i} className="mb-4">
                            <div className="flex justify-between mb-2">
                                <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                                <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                            </div>
                            <div className="h-1 bg-gray-200 rounded w-full"></div>
                        </div>
                    ))}
                </div>

                {/* Trips Overview Skeleton */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-[55%]">
                    <div className="h-6 bg-gray-200 rounded w-1/3 mb-6"></div>
                    <div className="overflow-x-auto">
                        <table className="min-w-full">
                            <thead>
                                <tr className="border-b border-gray-200">
                                    {[...Array(4)].map((_, i) => (
                                        <th key={i} className="pb-2">
                                            <div className="h-4 bg-gray-200 rounded w-20"></div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {[...Array(5)].map((_, i) => (
                                    <tr key={i} className="border-b border-gray-100">
                                        <td className="py-3">
                                            <div className="h-4 bg-gray-200 rounded w-32"></div>
                                        </td>
                                        <td className="py-3">
                                            <div className="h-4 bg-gray-200 rounded w-16 mx-auto"></div>
                                        </td>
                                        <td className="py-3">
                                            <div className="h-4 bg-gray-200 rounded w-16 mx-auto"></div>
                                        </td>
                                        <td className="py-3">
                                            <div className="h-4 bg-gray-200 rounded w-16 mx-auto"></div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}
